import React, { useState, createContext, useContext } from "react";
import {
  getAllQuickTales,
  getSingleUser,
} from "../../modules/OrganizationQuickTales/hooks/QuickTalesHooks";
import { useAuth } from "../../hooks";
import { getAllGAQuickTales } from "../../GeneralAdmin/modules/GAQuickTales/hooks/GAQuickTalesHooks";
import { getMostRecentUserContentReport } from "../../GeneralAdmin/modules/GAContentModeration/hooks/ContentReportsHooks";

export const QuickTalesContext = createContext();
export const useQuickTalesContext = () => useContext(QuickTalesContext);

export const QuickTalesProvider = ({ children }) => {
  const { currentUser, organizationId } = useAuth();

  // NOTE: AddSearch indexing was previously performed here via a raw browser
  // fetch that embedded the AddSearch site + secret keys in the client bundle.
  // That path has been removed (see docs/ADDSEARCH_REPLACEMENT_PLAN.md, Phase 0.1).
  // All AddSearch/search-index writes now go through the server-side
  // `updateQTInAddSearch` callable (temporary) and, going forward, the internal
  // `searchIndex` Firestore triggers. Never ship AddSearch secrets to the browser.

  // states
  const [allQuickTales, setAllQuickTales] = useState([]);
  const [approvedQuickTales, setApprovedQuickTales] = useState([]);
  const [pendingQuickTales, setPendingQuickTales] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [selected, setSelected] = useState([]);
  const [statusFilterOptions, setStatusFilterOptions] = useState([]);
  const [whoCanListenFilterOptions, setWhoCanListenFilterOptions] = useState(
    []
  );

  // Default sort for OrganizationQuickTales QuickTalesTable
  // Status Change Date (newest first)
  //const [order, setOrder] = useState("desc");
  //const [orderBy, setOrderBy] = useState("approvalStatus.updatedAt");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(200);

  // states
  //General Admin states
  const [GAQuickTales, setGAQuickTales] = useState([]);
  //General Admin states

  // useEffect(() => {
  //   handleGetAllQuickTales();
  // }, [currentUser]);

  const handleGetAllQuickTales = async () => {
    try {
      const querySnapshot = await getAllQuickTales(
        organizationId ? organizationId : currentUser.organization
      );
      const talesPromises = querySnapshot.docs.map(async (item) => {
        let docData = item.data();
        const userTemp = await getSingleUser(docData.createdBy);
        const narratorTemp = await getSingleUser(docData.narrator);
        let reactionReportsTemp = await getMostRecentUserContentReport(item.id);
        // console.log(reactionReportsTemp);
        let statusTemp = "";

        // Extract the status from the report, if it exists
        reactionReportsTemp.forEach((doc) => {
          // console.log("report::", doc);
          statusTemp = doc?.status?.status;
        });
        return {
          ...docData,
          photoUrl: docData?.imageUrls?.[0] ?? docData?.photoUrl ?? "",
          id: item.id,
          createdByData: userTemp?.data() ? userTemp.data() : null,
          narratorData: narratorTemp?.data() ? narratorTemp.data() : null,
          reportedStatus: statusTemp,
        };
      });

      const tales = await Promise.all(talesPromises);
      // Separate the tales into approved and pending
      const approvedTales = tales.filter(
        (tale) => tale.approvalStatus.status === "approved"
      );
      const pendingTales = tales.filter(
        (tale) => tale.approvalStatus.status !== "approved"
      );
      setApprovedQuickTales(approvedTales);
      setPendingQuickTales(pendingTales);
      setAllQuickTales(tales);
      // console.log("approved:", approvedTales);
      // console.log("pending:", pendingQuickTales);
      // console.log("all:", tales);
      return approvedTales;
    } catch (error) {
      console.error("Error fetching data from Firestore:", error.message);
      setLoading(false);
    }
  };

  //General Admin functions
  const handleGetGAQuickTales = async () => {
    try {
      setLoading(true);
      const querySnapshot = await getAllGAQuickTales();
      const talesPromises = querySnapshot.docs.map(async (item) => {
        let docData = item.data();
        const userTemp = await getSingleUser(docData.createdBy);
        const narratorTemp = await getSingleUser(docData.narrator);
        let reactionReportsTemp = await getMostRecentUserContentReport(item.id);
        // console.log(reactionReportsTemp);
        let statusTemp = "";

        // Extract the status from the report, if it exists
        reactionReportsTemp.forEach((doc) => {
          // console.log("report::", doc);
          statusTemp = doc?.status?.status;
        });
        return {
          ...docData,
          id: item.id,
          photoUrl: docData?.imageUrls?.[0] ?? docData?.photoUrl ?? "",
          createdByData: userTemp?.data() ? userTemp.data() : null,
          narratorData: narratorTemp?.data() ? narratorTemp.data() : null,
          reportedStatus: statusTemp,
        };
      });

      const tales = await Promise.all(talesPromises);

      setGAQuickTales(tales);
      console.log("all GA QTs:", tales);
    } catch (error) {
      console.error("Error fetching data from Firestore:", error.message);
    } finally {
      setLoading(false);
    }
  };
  //General Admin functions

  // AddSearch client-side indexing removed (Phase 0.1). Search-index writes are
  // handled server-side; see docs/ADDSEARCH_REPLACEMENT_PLAN.md.

  return (
    <QuickTalesContext.Provider
      value={{
        handleGetAllQuickTales,
        allQuickTales,
        setAllQuickTales,
        approvedQuickTales,
        setApprovedQuickTales,
        pendingQuickTales,
        setPendingQuickTales,
        loading,
        setLoading,
        filterModal,
        setFilterModal,
        selected,
        setSelected,
        statusFilterOptions,
        setStatusFilterOptions,
        whoCanListenFilterOptions,
        setWhoCanListenFilterOptions,
        //General admin section
        GAQuickTales,
        setGAQuickTales,
        handleGetGAQuickTales,
        //General admin section
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
      }}
    >
      {children}
    </QuickTalesContext.Provider>
  );
};
